import type { ModelDTO } from "@/store/api/dto/model.dto";
import type { BeeModelManager } from "../../beeorm/BeeModelManager";
import { BookModel } from "./BookModel";
import { CacheBookModelCollection } from "./CacheBookModelCollection";
import type { BookModelCollection } from "./BookModelCollection";

export class CacheBookModel extends BookModel {
  static cache = new WeakMap<ModelDTO, CacheBookModel>();
  constructor(modelManager: BeeModelManager, record: ModelDTO) {
    if (!CacheBookModel.cache.has(record)) {
      super(modelManager, record);
      CacheBookModel.cache.set(record, this);
    }

    return CacheBookModel.cache.get(record) as CacheBookModel;
  }

  static getCollectionClass() {
    return CacheBookModelCollection as typeof BookModelCollection<BookModel>;
  }
}
